// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `h5 {
  white-space: normal;
  padding-bottom: 5px;
}

h2 {
  font-weight: 600;
  white-space: normal;
  padding-bottom: 5px;
}

ion-icon {
  font-size: 20px;
  opacity: 0.9;
}

.div-thumb {
  position: relative;
  width: 70px;
}

ion-thumbnail {
  display: flex;
  justify-content: center;
  align-items: center;
  justify-content: center;
  align-items: center;
  position: relative;
  z-index: 1;
  border-radius: 100px;
}`, "",{"version":3,"sources":["webpack://./src/components/general components/item-history-list/item-history-list.component.scss","webpack://./src/components/general%20components/item-history-list/item-history-list.component.scss"],"names":[],"mappings":"AAAA;EACI,mBAAA;EACA,mBAAA;ACCJ;;ADEA;EACI,gBAAA;EACA,mBAAA;EACA,mBAAA;ACCJ;;ADEA;EAEI,eAAA;EACA,YAAA;ACAJ;;ADGA;EACI,kBAAA;EACA,WAAA;ACAJ;;ADGA;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,UAAA;EAEA,oBAAA;ACDJ","sourcesContent":["h5 {\n    white-space: normal;\n    padding-bottom:5px;\n}\n\nh2{\n    font-weight: 600;\n    white-space: normal;\n    padding-bottom:5px;\n}\n\nion-icon{\n    //color:white;\n    font-size:20px;\n    opacity: 0.9;\n}\n\n.div-thumb{\n    position: relative;\n    width:70px\n}\n\nion-thumbnail {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    justify-content: center;\n    align-items: center;\n    position: relative;\n    z-index: 1;\n    //background-color: var(--ion-color-primary);\n    border-radius: 100px;\n}","h5 {\n  white-space: normal;\n  padding-bottom: 5px;\n}\n\nh2 {\n  font-weight: 600;\n  white-space: normal;\n  padding-bottom: 5px;\n}\n\nion-icon {\n  font-size: 20px;\n  opacity: 0.9;\n}\n\n.div-thumb {\n  position: relative;\n  width: 70px;\n}\n\nion-thumbnail {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  justify-content: center;\n  align-items: center;\n  position: relative;\n  z-index: 1;\n  border-radius: 100px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
